import { IconClass } from './component/IconClass';

export const vars = IconClass.cssVarList;

const icon = {};

export default icon;

